import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { YouTubePreview } from 'APP/components/YouTubePreview/YouTubePreview';
import { LINK_PREVIEW_MAX_SIZE } from 'APP/constants/messages';
import { TextPayload } from 'STORE/Messages/Message/Payload/TextPayload/TextPayload';

import { ImagePreview } from './ImagePreview/ImagePreview';
import { useLinkPreviewPresenter } from './LinkPreview.presenter';
import styles from './LinkPreview.styles.m.css';

interface ILinkPreview {
  data: TextPayload['linkPreview'];
  messageId: string;
}

const LinkPreview: FC<ILinkPreview> = ({ data, messageId }) => {
  const presenter = useLinkPreviewPresenter({ data });

  return (
    <div className={styles.container}>
      <div className={styles.domain}>{data.domain}</div>
      <div className={styles.title}>{data.title}</div>
      {data.description && <div className={styles.description}>{data.description}</div>}

      {presenter.isImagePreview && (
        <ImagePreview
          resizedImage={presenter.resizedImage}
          data={data}
        />
      )}

      {presenter.isYouTubeVideo && (
        <YouTubePreview
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          id={messageId}
          className={styles.youtube}
          data={data}
          maxWidth={LINK_PREVIEW_MAX_SIZE.width}
          maxHeight={LINK_PREVIEW_MAX_SIZE.height}
        />
      )}
    </div>
  );
};

export default observer(LinkPreview);
